import { render, staticRenderFns } from "./DataAdminNewsList.vue?vue&type=template&id=497ae204&scoped=true&"
import script from "./DataAdminNewsList.vue?vue&type=script&lang=js&"
export * from "./DataAdminNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497ae204",
  null
  
)

export default component.exports